import { Component } from '@angular/core';
import { AdminapiService } from 'src/app/shared/services/adminapi.service';

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss']
})
export class AdminDashboardComponent {
  users=[];
  videos=[];
  purchases=[];
  constructor(public adminApi: AdminapiService){
    this.getDashboardData()
  }

  getDashboardData(){
    this.adminApi.dashboardData().subscribe((data: any) => {
      this.users = data.users
      this.videos = data.videos
      this.purchases = data.purchases
      
    });
  }
}
